function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import Matrix from './Matrix.js';
var Point = /*#__PURE__*/ function() {
    "use strict";
    function Point() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        _class_call_check(this, Point);
        this.init.apply(this, _to_consumable_array(args));
    }
    _create_class(Point, [
        {
            // Clone point
            key: "clone",
            value: function clone() {
                return new Point(this);
            }
        },
        {
            key: "init",
            value: function init(x, y) {
                var base = {
                    x: 0,
                    y: 0
                };
                // ensure source as object
                var source = Array.isArray(x) ? {
                    x: x[0],
                    y: x[1]
                } : (typeof x === "undefined" ? "undefined" : _type_of(x)) === 'object' ? {
                    x: x.x,
                    y: x.y
                } : {
                    x: x,
                    y: y
                };
                // merge source
                this.x = source.x == null ? base.x : source.x;
                this.y = source.y == null ? base.y : source.y;
                return this;
            }
        },
        {
            key: "toArray",
            value: function toArray() {
                return [
                    this.x,
                    this.y
                ];
            }
        },
        {
            key: "transform",
            value: function transform(m) {
                return this.clone().transformO(m);
            }
        },
        {
            // Transform point with matrix
            key: "transformO",
            value: function transformO(m) {
                if (!Matrix.isMatrixLike(m)) {
                    m = new Matrix(m);
                }
                var _this = this, x = _this.x, y = _this.y;
                // Perform the matrix multiplication
                this.x = m.a * x + m.c * y + m.e;
                this.y = m.b * x + m.d * y + m.f;
                return this;
            }
        }
    ]);
    return Point;
}();
export { Point as default };
export function point(x, y) {
    return new Point(x, y).transformO(this.screenCTM().inverseO());
}
